import { Expose } from 'class-transformer';

export class TrackAttempts {
  @Expose()
  failedAttempts?: number;
  @Expose()
  lastAttempt?: Date;
  @Expose()
  lockedOutUntil?: Date;
}
